module.exports = __webpack_public_path__ + "01_veryshort_brown.89bd3afc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_veryshort_brown.png
// module id = 4RYn
// module chunks = 0